import React, {useId, useState} from 'react';

export default function SourcingPanel({title, kind, children}) {
    const id = useId();
    const [collapsed, setCollapsed] = useState(false), [size, setSize] = useState('normal');
    return <section className={`sourcing-panel sourcing-panel--${kind}`} aria-label={title}>
        <header className="sourcing-panel-header">
            <h3>{title}</h3>
            <div className="sourcing-panel-actions">
                <button type="button" aria-label={`${collapsed ? 'Mostrar' : 'Ocultar'} ${title}`} aria-expanded={!collapsed} aria-controls={id} onClick={() => setCollapsed(v => !v)}>{collapsed ? 'Mostrar' : 'Ocultar'}</button>
                <button type="button" disabled={collapsed} aria-label={`${size === 'large' ? 'Reducir' : 'Ampliar'} ${title}`} onClick={() => setSize(v => v === 'large' ? 'normal' : 'large')}>{size === 'large' ? 'Reducir' : 'Ampliar'}</button>
            </div>
        </header>
        <div key={size} id={id} hidden={collapsed} className={`sourcing-panel-body sourcing-panel-body--${size}`} tabIndex={collapsed ? -1 : 0} aria-label={`Contenido de ${title}`}>
            {children}
        </div>
    </section>;
}

